import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IUserOTPLoginDetails } from 'Context/OTPLoginContext';

export interface IOTPLoginState {
  otpLoginDetails: IUserOTPLoginDetails | null;
}

const initialState: IOTPLoginState = {
  otpLoginDetails: null,
};

export const otpLoginSlice = createSlice({
  name: 'otp-login',
  initialState,
  reducers: {
    setOTPLogin: (
      state: IOTPLoginState,
      action: PayloadAction<IOTPLoginState | any>
    ) => {
      state.otpLoginDetails = action.payload;
    },
  },
});

export const { setOTPLogin } = otpLoginSlice.actions;

export default otpLoginSlice.reducer;
